import { Button } from './ui/button';
import { LogOut, LayoutDashboard, FileUp, Settings, CreditCard } from 'lucide-react';
import type { User, PageView } from '../App';

interface NavbarProps {
  user: User;
  onLogout: () => void;
  onNavigate: (page: PageView) => void;
  currentPage: PageView;
}

export function Navbar({ user, onLogout, onNavigate, currentPage }: NavbarProps) {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-[var(--navy)] border-b border-[rgba(201,168,76,0.2)] z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center gap-8">
            <button
              onClick={() => onNavigate('dashboard')}
              className="flex items-center gap-2 hover:opacity-90 transition-opacity"
            >
              <img src="/images/Corrected%20Logo.png" alt="Insolip" className="h-16 w-auto" />
            </button>

            <div className="hidden md:flex items-center gap-2">
              <Button
                variant={currentPage === 'dashboard' ? 'default' : 'ghost'}
                onClick={() => onNavigate('dashboard')}
                className={currentPage === 'dashboard' ? 'bg-[var(--gold)] text-[var(--navy)] hover:opacity-90' : 'text-white/80 hover:text-[var(--gold)]'}
              >
                <LayoutDashboard className="w-4 h-4 mr-2" />
                Dashboard
              </Button>

              {(user.role === 'innovator' || user.role === 'institution') && (
                <Button
                  variant={currentPage === 'submit' ? 'default' : 'ghost'}
                  onClick={() => onNavigate('submit')}
                  className={currentPage === 'submit' ? 'bg-[var(--gold)] text-[var(--navy)] hover:opacity-90' : 'text-white/80 hover:text-[var(--gold)]'}
                >
                  <FileUp className="w-4 h-4 mr-2" />
                  Submit Innovation
                </Button>
              )}
              {user.role === 'innovator' && (
                <Button
                  variant={currentPage === 'filing-doc-prep-pay' ? 'default' : 'ghost'}
                  onClick={() => onNavigate('filing-doc-prep-pay')}
                  className={
                    currentPage === 'filing-doc-prep-pay'
                      ? 'bg-[var(--gold)] text-[var(--navy)] hover:opacity-90'
                      : 'text-white/80 hover:text-[var(--gold)]'
                  }
                >
                  <CreditCard className="w-4 h-4 mr-2" />
                  Filing doc fee
                </Button>
              )}
              {user.role === 'institutional_admin' && (
                <Button variant="ghost" className="text-white/80 hover:text-[var(--gold)]" disabled>
                  <FileUp className="w-4 h-4 mr-2" />
                  Bulk upload (from dashboard)
                </Button>
              )}
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-white font-medium">{user.name}</div>
              <div className="text-white/60 text-sm capitalize">{user.role?.replace(/_/g, ' ') ?? ''}</div>
            </div>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => onNavigate('settings')}
              className={currentPage === 'settings' ? 'bg-white/10 text-[var(--gold)]' : 'text-white/80 hover:text-[var(--gold)]'}
            >
              <Settings className="w-4 h-4" />
            </Button>
            <Button variant="outline" onClick={onLogout} className="border-[rgba(201,168,76,0.3)] text-[var(--gold-light)] hover:bg-[var(--gold-pale)]">
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}